export { SiteShell as DiscoveryPageLayout, PageBackLink } from '@/platform/layout/SiteShell';
export type { SiteShellProps as DiscoveryPageLayoutProps } from '@/platform/layout/SiteShell';
